import React from 'react';

import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import type { OAISchema } from '~/types/openapi';
import { chunk } from '~/utils/array';

import ECouponProductCard from '../ECouponProductCard';
import ProductCard from '../ProductCard';

import styles from './index.module.css';

interface Props {
  data: OAISchema['MarketSelectProductResponseV2'][];
  eventOption?: Record<string, unknown>;
  onCartClick?: () => void;
}

const ProductGridDisplay = ({
  data = [],
  eventOption = {},
  onCartClick,
}: Props) => {
  const chunkedList = chunk(data, 2);

  return (
    <div className={styles.container}>
      {chunkedList.map((rows, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div className={styles.row} key={index}>
            {rows.map((item) => {
              return (
                <div className={styles.col} key={item.offerId}>
                  {item.productType === PRODUCT_TYPE_E_COUPON ? (
                    <ECouponProductCard
                      {...item}
                      eventOption={eventOption}
                      reverseCouponDiscountedPrice
                    />
                  ) : (
                    <ProductCard
                      {...item}
                      onCartClick={onCartClick}
                      eventOption={eventOption}
                      plusMembershipFullBadge
                      reverseCouponDiscountedPrice
                    />
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ProductGridDisplay;
